<template>
  <a-tooltip placement="bottom" :title="(!store_url || !is_storeactive) && $t('topBar.waitingApproval')" trigger="click">
    <div @click="handleClick" :class="(!store_url || !is_storeactive) && 'text-muted'">
      <a-icon type="appstore" class="mr-2" />
      {{ $t('topBar.myStore') }}
    </div>
  </a-tooltip>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('user', {
      store_url: state => state.store_url,
      is_storeactive: state => state.is_storeactive,
    }),
  },
  methods: {
    handleClick () {
      if (!this.store_url || !this.is_storeactive) {
        return
      }

      window.open(this.store_url, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
div {
  cursor: pointer;
  display: flex;
  align-items: center;
}
</style>
